import { route } from "@circle-react/lib/routes/define";

export const paywallGroupRoutes = {
  list: route("/settings/paywall_groups", {
    title: "Paywall groups",
    requires: "admin",
    description:
      "Lists all paywall groups (subscription groups) in the community's settings area.",
    queryParams: {
      page: {
        type: "number",
        description: "Pagination page number (default: 1).",
      },
    },
  }),
};
